import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import CategoriesForm from "../categories/CategoriesForm";
import { fetchBlogCategoriesData } from "../../../redux/ad-blog-reducers/blogSlice";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { add_blog, update_blog } from "../../../data/ApiEndpoints";
import BlogFormAIGenerated from "./BlogFormAIGenerated";
import BlogFormManualGenerated from "./BlogFormManualGenerated";

const BlogForm = ({
  userInfoData,
  isEdit,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);
  const { blogCategories } = useSelector((state) => state.blog);

  const [allBlogCategories, setAllBlogCategories] = useState([]);

  const [selectedTab, setSelectedTab] = useState(0);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isDisableSave, setIsDisableSave] = useState(true);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };

  const onSubmit = () => {
    setIsSubmit(true);
  };

  function getBlogCategories() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };

    dispatch(
      fetchBlogCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAdd = async (payload) => {
    const method = isEdit && selectedTab === 0 ? "PUT" : "POST";
    const endpoint = isEdit && selectedTab === 0 ? update_blog : add_blog;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getBlogCategories();
  }, []);

  useEffect(() => {
    if (blogCategories?.status && blogCategories?.data?.length > 0) {
      const allBlogs = blogCategories.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllBlogCategories(allBlogs);
    } else {
      setAllBlogCategories([]);
    }
  }, [blogCategories]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={() => setModValues(iniModvalues)}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <CategoriesForm
          userInfoData={userInfoData}
          rowData={modValues.rowData}
          isEdit={modValues.cardName === "edit"}
          closeModal={() => setModValues(iniModvalues)}
          callFunction={() => getBlogCategories()}
        />
      </Modal>

      <div className="createNewCTOModalContainer mealsModalContainer">
        <CommonHeadingNBtns
          title={`${isEdit ? "Update" : "Add New"} Blog`}
          onClose={closeModal}
          onClick={onSubmit}
          isLoading={postPutLoading || loading}
          isDisabled={selectedTab === 1 && isDisableSave}
        />

        <div className="blog-form-tabs-container mt30">
          <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
            <TabList>
              <Tab>Manual Blog Generate</Tab>
              <Tab>AI Blog Generate</Tab>
            </TabList>

            <TabPanel>
              <BlogFormManualGenerated
                userInfoData={userInfoData}
                isEdit={isEdit}
                rowData={rowData}
                allBlogCategories={allBlogCategories}
                handleAdd={handleAdd}
                isSubmit={isSubmit}
                setIsSubmit={setIsSubmit}
                setModValues={setModValues}
              />
            </TabPanel>

            <TabPanel>
              <BlogFormAIGenerated
                userInfoData={userInfoData}
                allBlogCategories={allBlogCategories}
                handleAdd={handleAdd}
                isSubmit={isSubmit}
                setIsSubmit={setIsSubmit}
                setModValues={setModValues}
                setIsDisableSave={setIsDisableSave}
              />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default BlogForm;
